module.exports = __webpack_public_path__ + "img/anchor.45ac8315.svg";